import React, { useEffect, useMemo, useState } from 'react'
import Card from 'react-bootstrap/Card'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap'
import SmsCampaignForm from './SmsCampaignForm'
import Controllers from '../../Api/Controllers'
import Helpers from '../../Components/Helpers/Helpers'
import { toast } from 'react-toastify'
import Swal from 'sweetalert2'

const SmsCampaign = ({ nameSingle, namePlural, separator }) => {
  const [isProcessing, setIsProccesing] = useState(true)
  const [reload, setReload] = useState(true)
  const [rows, setRows] = useState([])
  const [modalShow, setModalShow] = useState(false)
  const [detailShow, setDetailShow] = useState(false)
  const [detailLoading, setDetailLoading] = useState(false)
  const [detailMaster, setDetailMaster] = useState({})
  const [detailRows, setDetailRows] = useState([])
  const [loadSubmit, setLoadSubmit] = useState(false)

  useEffect(() => {
    if (reload) {
      setIsProccesing(true)
      Controllers.sms_campaign.get_all().then(res => setRows(res.data || [])).catch(req => Helpers.promise.catch({ req, toast }))
      .finally(() => { setIsProccesing(false); setReload(false) })
    }
  }, [reload])

  const handleInsert = async ({ data }) => {
    const { value: ok } = await Swal.fire({
      icon: 'question',
      title: '¿Crear campaña SMS?',
      html: `<div class="text-left">
              <div><strong>Nombre:</strong> ${data.p_name_campaign}</div>
              <div><strong>Programada:</strong> ${data.p_program ? data.p_scheduled_at : 'Inmediata'}</div>
            </div>`,
      showCancelButton: true,
      confirmButtonText: 'Crear',
      cancelButtonText: 'Cancelar'
    })
    if (!ok) return

    setLoadSubmit(true)
    Controllers.sms_campaign.create(data).then(res => {
      Helpers.toast.construct({ ...res, toast })
      if (res.response === 'success') setModalShow(false)
    }).catch(req => Helpers.promise.catch({ req, toast }))
    .finally(() => { setLoadSubmit(false); setReload(true) })
  }

  const doAction = async (row, action) => {
    const actionMap = {
      pause: { icon: 'warning', title: 'Pausar campaña', confirm: 'Pausar' },
      play: { icon: 'question', title: 'Reanudar campaña', confirm: 'Reanudar' },
      stop: { icon: 'error', title: 'Detener campaña', confirm: 'Detener' },
    }
    const cfg = actionMap[action]
    const { value: ok } = await Swal.fire({
      icon: cfg.icon,
      title: cfg.title,
      html: `<div class="text-left"><div><strong>ID:</strong> ${row.id_sms_campaign}</div><div><strong>Nombre:</strong> ${row.name_campaign}</div></div>`,
      showCancelButton: true,
      confirmButtonText: cfg.confirm,
      cancelButtonText: 'Cancelar'
    })
    if (!ok) return

    const map = { pause: Controllers.sms_campaign.pause, play: Controllers.sms_campaign.play, stop: Controllers.sms_campaign.stop }
    map[action]({ p_id: row.id_sms_campaign }).then(res => {
      Helpers.toast.construct({ ...res, toast })
      setReload(true)
    }).catch(req => Helpers.promise.catch({ req, toast }))
  }

  const statusBadge = (s) => {
    const map = { PENDING: 'info', RUNNING: 'primary', PAUSED: 'warning', STOPPED: 'dark', FINISHED: 'success' }
    const text = s
    return <span className={`badge badge-${map[s] || 'secondary'}`}>{text}</span>
  }

  const dtRows = useMemo(() => <ReactDataTableBootstrap
    head={[[
      { name: 'id_sms_campaign', text: 'ID', align: 'center' },
      { name: 'name_campaign', text: 'Nombre', align: 'center' },
      { name: 'message_text', text: 'Mensaje' },
      { name: 'scheduled_at', text: 'Programación', align: 'center', render: r => {
        const isScheduled = parseInt(r.is_scheduled || 0) === 1
        return <div>
          {isScheduled ? <span className="badge badge-info mr-1">Programada</span> : <span className="badge badge-secondary mr-1">Inmediata</span>}
          <small className="text-muted">{r.scheduled_at}</small>
        </div>
      } },
      { name: 'status_campaign', text: 'Estado', align: 'center', render: r => statusBadge(r.status_campaign) },
      { name: 'total_recipients', text: 'Destinatarios', align: 'center' },
      { name: 'sent_count', text: 'Enviados', align: 'center' },
      { name: 'failed_count', text: 'Fallidos', align: 'center' },
      { name: 'actions', text: <i className="fa fa-cog"></i>, align: 'center', render: u => {
        return <div>
          <Button size="xs" variant="info" className="mr-1" onClick={async () => {
            setDetailShow(true)
            setDetailLoading(true)
            try {
              const res = await Controllers.sms_campaign.get_id({ id: u.id_sms_campaign })
              setDetailMaster(res.data?.master || {})
              setDetailRows(res.data?.details || [])
            } catch (req) {
              Helpers.promise.catch({ req, toast })
            } finally {
              setDetailLoading(false)
            }
          }}><i className="fa fa-eye"></i></Button>
          {u.status_campaign === 'RUNNING' && <>
            <Button size="xs" variant="warning" className="mr-1" onClick={() => doAction(u,'pause')}><i className="fa fa-pause"></i></Button>
            <Button size="xs" variant="danger" className="mr-1" onClick={() => doAction(u,'stop')}><i className="fa fa-stop"></i></Button>
          </>}
          {u.status_campaign === 'PAUSED' && <>
            <Button size="xs" variant="success" className="mr-1" onClick={() => doAction(u,'play')}><i className="fa fa-play"></i></Button>
            <Button size="xs" variant="danger" onClick={() => doAction(u,'stop')}><i className="fa fa-stop"></i></Button>
          </>}
          {u.status_campaign === 'PENDING' && <Button size="xs" variant="danger" onClick={() => doAction(u,'stop')}><i className="fa fa-stop"></i></Button>}
        </div>
      }},
    ]]}
    rows={rows}
    isProcessing={isProcessing}
  />, [rows, isProcessing])

  return <>
    <Card>
      <Card.Header className="justify-content-between">
        <span>Campañas SMS</span>
        <Button size="sm" onClick={() => setModalShow(true)}>
          <i className="fa fa-plus mr-1"></i> Nueva Campaña
        </Button>
      </Card.Header>
      <Card.Body className="pt-3 pb-3">
        {dtRows}
      </Card.Body>
    </Card>

    <Modal show={modalShow} onHide={() => setModalShow(false)} backdrop="static" size="lg">
      <Modal.Header closeButton>
        <Modal.Title as="div">Nueva Campaña SMS</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <SmsCampaignForm onSubmit={handleInsert} loadSubmit={loadSubmit} />
      </Modal.Body>
    </Modal>

    <Modal show={detailShow} onHide={() => setDetailShow(false)} backdrop="static" size="lg">
      <Modal.Header closeButton>
        <Modal.Title as="div">Seguimiento Campaña #{detailMaster?.id_sms_campaign}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {detailLoading ? <div className="text-center"><i className="fa fa-circle-notch fa-spin"></i></div> : <>
          <div className="mb-3">
            <div className="mb-1"><strong>Nombre:</strong> {detailMaster?.name_campaign}</div>
            <div className="mb-1"><strong>Mensaje:</strong> {detailMaster?.message_text}</div>
            <div className="mb-1"><strong>Programación:</strong> {parseInt(detailMaster?.is_scheduled||0)===1 ? 'Programada' : 'Inmediata'} - <small className="text-muted">{detailMaster?.scheduled_at}</small></div>
            <div>
              <span className="badge badge-primary mr-2">Enviados: {detailMaster?.sent_count || 0}</span>
              <span className="badge badge-danger mr-2">Fallidos: {detailMaster?.failed_count || 0}</span>
              <span className="badge badge-info">Pendientes: {Math.max((detailMaster?.total_recipients||0) - (detailMaster?.sent_count||0) - (detailMaster?.failed_count||0), 0)}</span>
            </div>
          </div>
          <div style={{ maxHeight: 380, overflow: 'auto' }}>
            <table className="table table-sm table-bordered mb-0">
              <thead className="thead-light">
                <tr>
                  <th>ID Cliente</th>
                  <th>Teléfono</th>
                  <th>Estado</th>
                  <th>Fecha envío</th>
                  <th>Error</th>
                </tr>
              </thead>
              <tbody>
                {detailRows.length === 0 ? <tr><td colSpan={5} className="text-center text-muted">Sin detalles</td></tr> : detailRows.map(d => (
                  <tr key={d.id_sms_campaign_det}>
                    <td>{d.id_customers}</td>
                    <td>{d.phone}</td>
                    <td>{d.status_det === 'SENT' ? <span className="badge badge-success">SENT</span> : d.status_det === 'FAILED' ? <span className="badge badge-danger">FAILED</span> : <span className="badge badge-secondary">PENDING</span>}</td>
                    <td>{d.sent_at || ''}</td>
                    <td>{d.error_message || ''}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>}
      </Modal.Body>
    </Modal>
  </>
}

SmsCampaign.defaultProps = {
  nameSingle: 'Campaña',
  namePlural: 'Campañas',
  separator: 'la'
}

export default SmsCampaign


